import React, {useEffect, useState, useCallback, useRef} from 'react';
import {connect} from 'react-redux';
import {withRouter, Link} from 'react-router-dom';
import {Menu} from '../../utils/menu/Menu';
import {formatErrors, roleAdmin, roleTechnicalSpecialist, roleCurator} from '../../constants';
import {toast} from 'react-toastify';
import {InputSearch} from '../../utils/inputSearch/InputSearch';
import {SortItem} from '../../utils/sortItem/SortItem';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {Pagination} from '../../utils/pagination/Pagination';
import {getcourseDataAction} from "../../actions/getcourseDataAction";
import {MenuHeader} from "../../utils/menu/MenuHeader";

const GetcourseData = (props) => {
  const {user, isAdmin, getClients, isTechnicalSpecialist} = props;
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({});
  const [checked, setChecked] = useState({});
  const [checkedAll, setCheckedAll] = useState(false);
  const abortRef = useRef(null);

  const handleChangeFilter = useCallback((field, value) => {
    setFilter((data) => {
      return {...data, [field]: value, page: 1}
    });
  }, []);

  const handleChangePage = useCallback((value) => {
    setFilter((data) => {
      return {...data, page: value}
    });
  }, []);

  const handleChangeSort = useCallback((sort, sortd) => {
    setFilter((data) => {
      return {...data, sort, sortd}
    });
  }, []);

  // get clients list
  const getClientsList = useCallback((filter) => {
    if (abortRef && abortRef.current) {
      abortRef.current.abort();
    }
    const abortNew = new AbortController();
    abortRef.current = abortNew;
    getClients(filter, isAdmin, abortRef && abortRef.current ? abortRef.current.signal : null, isTechnicalSpecialist).then((data) => {
      abortRef.current = null;
      setItems(data.items || []);
      setTotal(data.total);
      setChecked({});
      setCheckedAll(false);
      localStorage.setItem('dc_currentGetcourseDataFilter', JSON.stringify(filter));
    }).catch(err => {
      if (err.name !== 'AbortError') {
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
      }
      abortRef.current = null;
    });
  }, [getClients, isAdmin, isTechnicalSpecialist]);

  // get clients list on change filter
  useEffect(() => {
    if (filter.page) {
      getClientsList(filter);
    }
  }, [filter, getClientsList]);

  useEffect(() => {
    if (!user || !user.id) {
      return;
    }
    const baseFilter = {page: 1, limit: 10, search: '', sort: 'email', sortd: 'asc', curator_id: '', course: 0};
    let curFilter = localStorage.getItem('dc_currentGetcourseDataFilter');
    curFilter = curFilter ? JSON.parse(curFilter) : baseFilter;
    curFilter.page = !curFilter.page ? 1 : curFilter.page;
    if (user.role_id === roleCurator) {
      curFilter.curator_id = user.id;
    } else {
      curFilter.curator_id = "";
    }
    setFilter(curFilter);
  }, [user]);

  return <div className="content">
    <Menu isStatic={user.role_id === roleCurator ? false : true}/>

    {(isAdmin || isTechnicalSpecialist) && <div className="heading heading--flex">
      <h2 className="heading__title">Пользователи getcourse</h2>
      <div className="heading__group">
        
      </div>

      {filter.page && filter.page > 0 && <InputSearch className="heading__input"
                                                          value={filter.search}
                                                          loading={loading}
                                                          handleChange={handleChangeFilter} />}
    </div>}
    {!isAdmin && !isTechnicalSpecialist && <MenuHeader>
      <React.Fragment>
        <h2 className="header__title">Пользователи getcourse <span>{total}</span></h2>
        <div className="heading__group">
            
        </div>
        {filter.page && filter.page > 0 && <InputSearch className="heading__input"
                                                        value={filter.search}
                                                        loading={loading}
                                                        handleChange={handleChangeFilter} />}
      </React.Fragment>
    </MenuHeader>}

    <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="ФИО" className="sort__item--name" sort="last_name" sortd={filter.sort === "last_name" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Телефон" className="sort__item--phone" sort="phone" sortd={filter.sort === "phone" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="E-mail" className="sort__item--email" sort="email" sortd={filter.sort === "email" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Uid" className="sort__item--phone" sort="uid" sortd={filter.sort === "uid" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Real name" className="sort__item--name" sort="real_name" sortd={filter.sort === "real_name" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Product title" className="sort__item--name" sort="product_title" sortd={filter.sort === "product_title" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Start at" className="sort__item--name" sort="start_at" sortd={filter.sort === "start_at" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Finish at" className="sort__item--name" sort="finish_at" sortd={filter.sort === "finish_at" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Product title part2" className="sort__item--name" sort="product_title_part2" sortd={filter.sort === "product_title_part2" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Start at part2" className="sort__item--name" sort="start_at_part2" sortd={filter.sort === "start_at_part2" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Finish at part2" className="sort__item--name" sort="finish_at_part2" sortd={filter.sort === "finish_at_part2" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Product title part3" className="sort__item--name" sort="product_title_part3" sortd={filter.sort === "product_title_part3" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Start at part3" className="sort__item--name" sort="start_at_part3" sortd={filter.sort === "start_at_part3" ? filter.sortd : ""} onChange={handleChangeSort}/>
          <SortItem title="Finish at part3" className="sort__item--name" sort="finish_at_part3" sortd={filter.sort === "finish_at_part3" ? filter.sortd : ""} onChange={handleChangeSort}/>
        </div>
        <div className="users__inner">
          {
            items && items.length > 0 && items.map((i) => <div key={i.id} className="users__item">
              <span className="users__name">{i.last_name} {i.first_name} {i.patronymic_name}</span>
              <span className="users__phone">{i.phone}</span>
              <span className="users__email">{i.email}</span>
              <span className="users__phone">{i.uid}</span>
              <span className="users__name">{i.real_name}</span>
              <span className="users__name">{i.product_title}</span>
              <span className="users__name">{i.start_at}</span>
              <span className="users__name">{i.finish_at}</span>
              <span className="users__name">{i.product_title_part2}</span>
              <span className="users__name">{i.start_at_part2}</span>
              <span className="users__name">{i.finish_at_part2}</span>
              <span className="users__name">{i.product_title_part3}</span>
              <span className="users__name">{i.start_at_part3}</span>
              <span className="users__name">{i.finish_at_part3}</span>
              {(isAdmin || isTechnicalSpecialist) && <ButtonMore>
                <ul className="dropdown">
                  {<li className="dropdown__item icon-edit">
                    {user.id !== i.id && <Link to={'/getcourse_data_item/' + i.id}>Редактировать</Link>}
                  </li>}
                </ul>
              </ButtonMore>}
            </div>)
          }
        </div>
      </div>
    </div>

    {filter.page && filter.page > 0 && <Pagination page={filter.page} total={total} limit={filter.limit} onChange={handleChangePage}/>}
  </div>;
};

const mapStateToProps = (state) => ({
  user: state.user.profile,
  isAdmin: state.user.profile && state.user.profile.role_id === roleAdmin,
  isTechnicalSpecialist: state.user.profile && state.user.profile.role_id === roleTechnicalSpecialist
});

const mapDispatchToProps = (dispatch) => {
  return {
    getClients(data, isAdmin, signal) {
      return dispatch(getcourseDataAction(data, isAdmin, signal));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GetcourseData))
